const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Days elapsed since `from` until `now`, computed as **whole 24-hour buckets**
 * (e.g. 23h ago → 0, 24h ago → 1, 49h ago → 2).
 *
 * Returns `null` when `from` is missing or unparsable.
 */
export const computeDaysSince = (from: Date | null | undefined, now: Date = new Date()): number | null => {
  if (!from) return null;
  const diffMs = now.getTime() - from.getTime();
  if (diffMs < 0) return 0;
  return Math.floor(diffMs / MS_PER_DAY);
};
